import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Link } from 'react-router-dom';
import icon1 from "../../assets/img/icon/pepicons-print_person.png";
import icon2 from "../../assets/img/icon/light_add-business.png";
import AuthHeader from '../../components/Navbar/AuthHeader';
import ProgressSteps from '../../components/ProgressStep/ProgressSteps';

import '../../styles/auth.css';
import { FaArrowLeftLong } from 'react-icons/fa6';


function GetStarted() {
  const location = useLocation();
  const businessAccountDisabled = false;
  const publicUrl = process.env.REACT_APP_PUBLIC_URL;

  useEffect(() => {
    localStorage.removeItem('account_type');
    localStorage.removeItem('email');
    const params = new URLSearchParams(location.search);
    const referralCode = params.get('ref');
    if (referralCode) {
      localStorage.setItem('referral_code', referralCode);
    }
  }, [location.search]);
  
  return (
    <div style={{background: '#13053A',minHeight: '100vh'}}>
      <AuthHeader />
      <div className="auth__container padding__tb__30">
        <div className='auth__container__box'>
            <h3>What kind of account would you like to open today?</h3>
            <p className='auth__text'>Enjoy the flexibility of adding another account anytime.</p>
            {/* Progress Dots */}
            <ProgressSteps currentStep={1} totalSteps={4} />
            <div className='auth__container__cards mb-4'>
                <Link to='/getstarted/email-verification' className='auth__container__box__card text-decoration-none'
                  onClick={() => localStorage.setItem('account_type', 'personal')}
                >
                    <div className='auth__container__box__card__icon'>
                        <img src={icon1} alt='' className='img-fluid'/>
                    </div>
                    <div className='auth__container__box__card__content'>
                        <h4>Personal Account</h4>
                        <p>
                            Built for individuals who want to send, receive and spend smarter anytime, anywhere.
                        </p>
                    </div>
                </Link>
                <Link to={businessAccountDisabled ? '#' : '/getstarted/email-verification'} className='auth__container__box__card text-decoration-none'
                  onClick={(e) => {
                    if(businessAccountDisabled){
                      e.preventDefault();
                      e.stopPropagation();
                    }else{
                      localStorage.setItem('account_type', 'business')
                    }
                  }}>
                   <div className='auth__container__box__card__icon'>
                        <img src={icon2} alt='' className='img-fluid'/>
                   </div>
                   <div className='auth__container__box__card__content'>
                      <h4>Business Account</h4>
                      <p>
                        {businessAccountDisabled ?
                          'Coming Soon.' :
                          'Designed for business owners, entrepreneurs and teams to manage transactions and scale globally.'
                        }
                      </p>
                   </div>
                </Link>
            </div>
            <p className='auth__container__box__text'>By registering you accept our 
              <Link to={`${publicUrl}/legal`} rel='noopener noreferrer' target='_blank'> Terms of use </Link> and
              <Link to={`${publicUrl}/privacy-policy`} rel='noopener noreferrer' target='_blank'> Privacy Policy</Link>
            </p>

            <div>
              {/* <Link to={-1}> */}
              <p className='text-center'>
                <Link to='/login'>
                  <FaArrowLeftLong className='auth__back__arrow' />
                  &nbsp; Back To Login
                </Link>
              </p>
            </div>
        </div>
      </div>
    </div>
  )
}

export default GetStarted